import React, { useState, useEffect, useRef  } from "react"; 
import "./servicedetail.css"
import { a } from "react-router-dom";
import AOS from "aos";
import { FaChevronDown } from "react-icons/fa";
import servicebanner from '../../../img/service_image.jpg';
import work1 from '../../../img/FOTWW.png';
import work2 from '../../../img/Dakzy cover.png';   
import work3 from  '../../../img/yacebazar.png';
import work4 from  '../../../img/girls slay cover.png';




const faqs = [
  {
    id: 1,
    title: "01. Streamline Business Processes",
    content: "Custom software solutions enhance operational efficiency and reduce manual work."
  },
  {
    id: 2,
    title: "02. Data-Driven Insights",
    content: "Analytics and tracking allow businesses to make informed decisions for better outcomes."
  },
  {
    id: 3,
    title: "03. Cost-Effective Growth",
    content: "Investing in scalable IT solutions saves costs in the long run and supports future expansion."
  },
  {
    id: 4,
    title: "04. Enhanced User Experience",
    content: "Professional websites, apps, and software ensure an intuitive and engaging experience for your customers."
  },
  {
    id: 5,
    title: "05. Cost-Effective Marketing",
    content: "SEO offers a cost-effective way to reach target audiences and drive organic traffic to a website."
  },
  {
    id: 6,
    title: "06. Long-Term Results",
    content: "SEO efforts can provide long-term benefits by maintaining and improving search engine rankings over time."
  },
  {
    id: 7,
    title: "07. Brand Credibility",
    content: "A well-maintained online presence boosts your brand's credibility and trustworthiness."
  },
  {
    id: 8,
    title: "08. Competitive Edge",
    content: "Having the right IT solutions gives your business a significant advantage over competitors."
  }
];
// Time line 
const timelineData = [
  {
    step: '01',
    tag: 'step 01',
    title: 'Discovery Phase',
    description:
      'During this initial stage, we delve deep into understanding your business goals, target audience, and market landscape. We conduct thorough research and analysis to identify opportunities and challenges, laying the foundation for a successful campaign.'
  },
  {
    step: '02',
    tag: 'step 02',
    title: 'Strategy Development',
    description:
      'With insights gathered from the discovery phase, we develop a customized strategy tailored to your specific needs and objectives. This comprehensive plan outlines the key tactics, channels, and timelines needed to achieve your business goals effectively.'
  },
  {
    step: '03',
    tag: 'step 03',
    title: 'Implementation and Execution',
    description:
      'Once the strategy is finalized and approved, we roll up our sleeves and put the plan into action. Our expert team utilizes cutting-edge tools and techniques to execute each component of the strategy with precision and efficiency.'
  },
  {
    step: '04',
    tag: 'step 04',
    title: 'Monitoring and Optimization',
    description:
      'Continuous monitoring and optimization are essential to ensuring the success and effectiveness of our campaigns. We closely track key performance indicators and adjust the strategy accordingly.'
  }
];

// Faq 

const faqData = [
  {
    question: "What services does your company offer?",
    answer:
      "We offer a wide range of IT services, including website development, mobile app development, digital marketing, software development, staff augmentation, and UI/UX design."
  },
  {
    question: "Do you work with startups as well as established enterprises?",
    answer:
      "Yes, we cater to both startups and established businesses. Our flexible service models are designed to meet the specific needs of clients, regardless of their size."
  },
  {
    question: "Can you handle international projects?",
    answer:
      "Yes, we have experience working with clients globally, and we ensure seamless communication and project management across different time zones."
  },
  {
    question: "What platforms do you use for website development?",
    answer:
      "We develop websites using modern platforms and frameworks such as Laravel, CodeIgniter, Shopify, WordPress, and the MERN stack (MongoDB, Express.js, React, Node.js)."
  },
  {
    question: "Will the website be optimized for search engines (SEO)?",
    answer:
      "Yes, we ensure SEO optimization with proper meta tags, fast loading speeds, mobile responsiveness, and schema markup to improve search engine rankings."
  },
  {
    question: "Do you develop apps for both Android and iOS?",
    answer:
      "Yes, we develop native apps for both Android and iOS, as well as cross-platform apps using Flutter and React Native for faster development and lower costs."
  },
  {
    question: "How do you measure the success of digital marketing campaigns?",
    answer:
      "We use key performance indicators (KPIs) such as website traffic, conversion rates, click-through rates (CTR), and return on investment (ROI) to measure the success of our campaigns."
  }
];

function Servicedetail() {


  //   FAQ//
   
      
  const [activeIndex, setActiveIndex] = useState(null);
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  // Fade Animation on scroll//
          useEffect(() => {
              AOS.init({ duration: 1000, once: true });
            }, []);




            useEffect(() => {
                const timelineEl = document.querySelector('.timeline');
                const handleScroll = () => {
                  const rect = timelineEl.getBoundingClientRect();
                  if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                    timelineEl.classList.add('animate-track');
                  }
                };
            
                window.addEventListener('scroll', handleScroll);
                return () => window.removeEventListener('scroll', handleScroll);
              }, []);
            
            
              const timelineRef = useRef(null);
              const trackRef = useRef(null);
              const [visibleItems, setVisibleItems] = useState([]);
            
              useEffect(() => {
                const handleScroll = () => {
                  const scrollTop = window.scrollY;
                  const viewPoint = scrollTop + window.innerHeight * 0.5;
            
                  const items = document.querySelectorAll('.timeline__item');
                  const visible = [];
            
                  items.forEach((item, idx) => {
                    const top = item.offsetTop;
                    const bottom = top + item.offsetHeight;
            
                    if (viewPoint > top && viewPoint < bottom) {
                      visible.push(idx);
                    } else if (viewPoint > bottom) {
                      visible.push(idx);
                    }
                  });
            
                  setVisibleItems(visible);
                  updateTrack();
                };
            
                const updateTrack = () => {
                  if (!trackRef.current || !timelineRef.current) return;
            
                  const timelineTop = timelineRef.current.offsetTop;
                  const scrollY = window.scrollY + window.innerHeight * 0.5;
            
                  // Get the total height of the timeline section
                  const sectionHeight = timelineRef.current.offsetHeight;
            
                  // Calculate the desired height for the track
                  const desiredHeight = scrollY - timelineTop;
            
                  // Make sure the track height does not exceed the section height
                  const finalHeight = Math.min(desiredHeight, sectionHeight);
            
                  trackRef.current.style.height = `${finalHeight > 0 ? finalHeight : 0}px`;
                };
            
            
                window.addEventListener('scroll', handleScroll);
                window.addEventListener('resize', handleScroll);
            
                handleScroll();
            
            
              }, []);

  const [activeBenefitIndex, setActiveBenefitIndex] = useState(null);

  const toggleBenefitAccordion = (index) => {
    setActiveBenefitIndex(activeBenefitIndex === index ? null : index);
  };

    return(
        <div>

  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-12 fade-in-top">
        <div className="service-details">
          <h2 className="service-title">Service Details</h2>
          <p className="service-description">
            We specialize in delivering top-notch IT solutions tailored to your
            unique business needs. Our dedicated team of experts ensures that
            you get innovative, efficient, and scalable services to help your
            brand thrive in a digital-first world.
          </p>
          <a href="/contact" className=" btn-get-startedA">
            GET STARTED
          </a>
        </div>
      </div>
    </div>
    <div className="image" data-aos="fade-up" data-aos-delay={0}>
      <img src={servicebanner} />
    </div>
    <div className="row mt-5">
      <div className="col-lg-12" data-aos="fade-up" data-aos-delay={0}>
        <div className="why-header">
          <span>BENEFITS</span>
          <h1>Why you Need this Service</h1>
        </div>
        {/* <span class="benefits-tag"></span>
  <h1 class="why-need-title"> */}
        <p className="why-need-description">
          In today's fast-paced digital world, having a strong online presence
          and efficient digital solutions is crucial for any business. Here's
          why you need our services:
        </p>
      </div>
    </div>
    <div className="row">
      {faqs.slice(0, 4).map((item, idx) => (
        <div className="col-lg-6 col-md-6 col-sm-6" key={item.id}>
          <div
            className={`accordion faq-A${activeBenefitIndex === idx ? " active" : ""}`}
          >
            <div className="accordion-header" onClick={() => toggleBenefitAccordion(idx)}>
              <h3>{item.title}</h3>
              <div className="plus-box">
                <span className="plus-symbol">{activeBenefitIndex === idx ? "-" : "+"}</span>
              </div>
            </div>
            <div
              className="accordion-content"
              style={{ maxHeight: activeBenefitIndex === idx ? "150px" : "0" }}
            >
              <p>{item.content}</p>
            </div>
          </div>
        </div>
      ))}
      {faqs.slice(4, 8).map((item, idx) => (
        <div className="col-lg-6 col-md-6 col-sm-6" key={item.id}>
          <div
            className={`accordion faq-A${activeBenefitIndex === idx + 4 ? " active" : ""}`}
          >
            <div className="accordion-header" onClick={() => toggleBenefitAccordion(idx + 4)}>
              <h3>{item.title}</h3>
              <div className="plus-box">
                <span className="plus-symbol">{activeBenefitIndex === idx + 4 ? "-" : "+"}</span>
              </div>
            </div>
            <div
              className="accordion-content"
              style={{ maxHeight: activeBenefitIndex === idx + 4 ? "150px" : "0" }}
            >
              <p>{item.content}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
  <section
    className="what-we-do-section"
    data-aos="fade-up"
    data-aos-delay={100}
  >
    <span className="servicedetail-tag">Service Details</span>
    <h2>What We Do</h2>
    <p>
      At our Company, we specialize in delivering top-notch IT solutions
      tailored to your unique business needs. Our dedicated team of experts
      ensures that you get innovative, efficient, and scalable services to help
      your brand thrive in a digital-first world.
    </p>
    <ul className="services-list">
      <li data-aos="fade-up" data-aos-delay={0}>
        <span>Website Development:</span>
        <p>
          Crafting websites that leave a lasting impression! Our website
          development services focus on creating responsive, user-friendly, and
          SEO-optimized websites. Whether it's a sleek corporate site, a dynamic
          e-commerce platform, or a custom web application, we ensure a seamless
          digital experience.
        </p>
      </li>
      <li data-aos="fade-up" data-aos-delay={100}>
        <span>Mobile App Development:</span>
        <p>
          We bring your ideas to life with cutting-edge mobile applications! Our
          mobile app development services cover both iOS and Android platforms,
          delivering intuitive apps that boost engagement and drive growth.
        </p>
      </li>
      <li data-aos="fade-up" data-aos-delay={200}>
        <span>Digital Marketing:</span>
        <p>
          Enhance your online presence with our comprehensive digital marketing
          solutions. From increasing website traffic to generating quality
          leads, we craft strategies that deliver measurable results.
        </p>
      </li>
      <li data-aos="fade-up" data-aos-delay={300}>
        <span>Content Marketing:</span>
        <p>
          Engage, inform, and inspire your audience with high-quality content.
          Our content marketing services help build trust and authority in your
          industry by delivering value-driven content tailored to your brand
          voice.
        </p>
      </li>
      <li data-aos="fade-up" data-aos-delay={400}>
        <span>Figma Design:</span>
        <p>
          Turn your vision into reality with stunning UI/UX designs crafted in
          Figma. Our design experts create intuitive and aesthetically pleasing
          interfaces that enhance user experience and engagement.
        </p>
      </li>
      <li data-aos="fade-up" data-aos-delay={500}>
        <span>Software Development:</span>
        <p>
          Transform your business operations with custom software solutions
          designed to meet your specific requirements. Our software development
          services ensure seamless performance and scalability.
        </p>
      </li>
    </ul>
  </section>
  <section className="why-choose-section" data-aos="fade-up" data-aos-delay={0}>
    <div className="container-fluid p-5">
      <div className="text-center mb-5" data-aos="fade-up" data-aos-delay={100}>
        <span className="badgeA text-uppercase ">Why Choose Us</span>
        <h2 className="mt-3 your-best-text">
          Why we are your best
          <br /> choice
        </h2>
      </div>
      <div className="row">
        <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay={0}>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fa-solid fa-rocket" />
            </div>
            <h3 className="feature-titleA">Proven Track Record</h3>
            <p className="feature-description">
              We have built a reputation as a trusted and reliable partner in
              achieving business success.
            </p>
          </div>
        </div>
        <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay={100}>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fa-solid fa-hexagon-nodes" />
            </div>
            <h3 className="feature-titleA">Tailored Solutions</h3>
            <p className="feature-description">
              We offer personalized solutions tailored to your specific goals,
              audience, and industry.
            </p>
          </div>
        </div>
        <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay={200}>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fa-solid fa-users-viewfinder" />
            </div>
            <h3 className="feature-titleA">Client-Centric Focus</h3>
            <p className="feature-description">
              Your success is our priority. We prioritize understanding your
              business goals.
            </p>
          </div>
        </div>
        <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay={300}>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fa-regular fa-comments" />
            </div>
            <h3 className="feature-titleA">Transparent Communication</h3>
            <p className="feature-description">
              We believe in open and honest communication every step of the way.
            </p>
          </div>
        </div>
        <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay={400}>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fa-solid fa-hand-holding-heart" />
            </div>
            <h3 className="feature-titleA">Dedicated Support</h3>
            <p className="feature-description">
              Your success is our priority, and we're here to support you every
              step of the way.
            </p>
          </div>
        </div>
        <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay={500}>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fa-solid fa-atom" />
            </div>
            <h3 className="feature-titleA">Expertise Across Industries</h3>
            <p className="feature-description">
              Our team has extensive experience working across various
              industries.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section
    className="carousel-container text-center"
    data-aos="fade-up"
    data-aos-delay={0}
  >
    <span className="proof-tag" data-aos="fade-up" data-aos-delay={100}>
      Brands
    </span>
    <h2 className="carousel-title" data-aos="fade-up" data-aos-delay={200}>
      Brands that Took Our Services
    </h2>
    <div className="slider-containerA" data-aos="fade-up" data-aos-delay={0}>
      <div className="slider">
        <div className="card-service">
          <div className="testimonial-cardA">
            <div className="review-starsA">★ ★ ★ ★ ★</div>
            <p className="">
              Choosing CodeQlik was one of the best decisions we made for our
              company. Their innovative approach and dedication to understanding
              our unique needs resulted in a tailored marketing strategy that
              exceeded our expectations. Their team's unwavering support and
              consistent communication made the entire process seamless. We're
              thrilled with the outcome and look forward to continued success
              together.
            </p>
            <hr />
            <h5> Mansigh Rajput</h5>
            <small> M.D. BrightStar Technologies</small>
          </div>
        </div>
        <div className="card-service">
          <div className="testimonial-cardA">
            <div className="review-starsA">★ ★ ★ ★ ★</div>
            <p className="">
              CodeQlik has been instrumental in transforming our online
              presence. Their expertise across various digital marketing
              channels, coupled with their data-driven approach, has
              significantly boosted our visibility and engagement.{" "}
            </p>
            <hr />
            <h5> Mohan Panwar</h5>
            <small>CEO, Brightsun</small>
          </div>
        </div>
        <div className="card-service">
          <div className="testimonial-cardA">
            <div className="review-starsA">★ ★ ★ ★ ★</div>
            <p className="">
              Working with CodeQlik has been a game-changer for our business.
              Their tailored strategies and deep expertise in digital marketing
              have propelled our brand to new heights. Their commitment to
              transparency and communication has made them a true partner in our
              success. We couldn't be happier with the results!{" "}
            </p>
            <hr />
            <h5> S. Kumar </h5>
            <small> BlueSky Ventures</small>
          </div>
        </div>
        <div className="card-service">
          <div className="testimonial-cardA">
            <div className="review-starsA">★ ★ ★ ★ ★</div>
            <p className="">
              I've been using this company's IT services for over a year, and I
              can confidently say their customer support is exceptional. Their
              team is always available to resolve issues efficiently and
              professionally."
            </p>
            <hr />
            <h5>Amit Verma</h5>
            <small>CTO, NexaTech Solutions</small>
          </div>
        </div>
        <div className="card-service">
          <div className="testimonial-cardA">
            <div className="review-starsA">★ ★ ★ ★ ★</div>
            <p className="">
              We've relied on this company's IT services for over a year, and
              their support has been outstanding. The team is highly responsive
              and always resolves issues swiftly and professionally."
            </p>
            <hr />
            <h5>Neha Kapoor</h5>
            <small>CEO, InnovateTech Solutions</small>
          </div>
        </div>
        <div className="card-service">
          <div className="testimonial-cardA">
            <div className="review-starsA">★★★★★</div>
            <p className="">
              Exceptional service and support! Their IT team is always available
              and ensures that any issues are resolved quickly and efficiently.
              Highly recommended!"
            </p>
            <hr />
            <h5>Rohan Malhotra</h5>
            <small>COO, DigitalWave Technologies</small>
          </div>
        </div>
        <div className="card-service">
          <div className="testimonial-cardA">
            <div className="review-starsA">★ ★ ★ ★ ★</div>
            <p className="">
              Professional and reliable IT services! Their team is always ready
              to assist, and their customer support is top-notch. It's been a
              pleasure working with them.
            </p>
            <hr />
            <h5>Priya Mehta</h5>
            <small>Founder, CloudSphere Systems</small>
          </div>
        </div>
  
      </div>
    </div>
  </section>
  <section className="gallery-section" data-aos="fade-up" data-aos-delay={0}>
    <span className="proof-tag" data-aos="fade-up" data-aos-delay={100}>
      proof
    </span>
    <h2 className="your-best-text" data-aos="fade-up" data-aos-delay={200}>
      Some Samples of Our Works
    </h2>
    <div className="gallery-container">
      {/* Row 1 */}
      <div className="gallery-item" data-aos="fade-up" data-aos-delay={100}>
        <a href="/projects">
          <img src={work1} alt="about technology and trends" />
        </a>
      </div>
      <div
        className="gallery-item active"
        data-aos="fade-up"
        data-aos-delay={200}
      >
        <a href="/projects">
          <img src={work2} alt="about technology and trends" />
        </a>
      </div>
      {/* Row 2 */}
      <div
        className="gallery-item active"
        data-aos="fade-up"
        data-aos-delay={100}
      >
        <a href="/projects">
          <img src={work3} alt="about technology and trends" />
        </a>
      </div>
      <div className="gallery-item" data-aos="fade-up" data-aos-delay={200}>
        <a href="/projects">
          <img src={work4} alt=" about technology and trends" />
        </a>
      </div>
 
    </div>
  </section>
  <div className="container " data-aos="fade-up" data-aos-delay={0}>
    <div className="text-center my-5">
      <span className="we-work-tag">How We Work</span>
      <h2 className="mt-2 text-white">Our 4 Stage Process</h2>
    </div>
    </div>
     <section className="timeline-section">
        <div className="medium-container">
          <div className="timeline" ref={timelineRef}>
            {timelineData.map((item, idx) => (
              <div
                key={idx}
                className={`timeline__item ${visibleItems.includes(idx) ? 'is-visible' : ''
                  }`}
              >
                <div className="timeline__line"></div>
                <div className="timeline__wrap">
                  <div
                    className={
                      idx % 2 === 0 ? 'timeline-step' : 'timeline-step2'
                    }
                  >
                    {item.step}
                  </div>
                  <span className="step-tag">{item.tag}</span>
                  <h5>{item.title}</h5>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}

            <div className="timeline__track" ref={trackRef}></div>
          </div>
        </div>
      </section>
   
  <section className="accordion-bg">
    <div
      className="accordion-box text-center"
      data-aos="fade-up"
      data-aos-delay={0}
    >
      <span className="we-work-tag">Frequently Asked Questions</span>
    </div>
    <div className="accordion-section" data-aos="fade-up" data-aos-delay={100}>
      <h1>
        Got Questions <br /> We've Got Answers!
      </h1>
    </div>
     
      {faqData.map((item, index) => (
            <div key={index}
              className={`accordion ${activeIndex === index ? "active" : ""}`}
             >
              <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                <h3>{item.question}</h3>
                <div className="caret-box">
                  <FaChevronDown
                    className={`caret ${activeIndex === index ? "rotate" : ""}`}/>
                </div>
              </div>
              <div className="accordion-content"
                style={{ maxHeight: activeIndex === index ? "150px" : "0" }}>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
  </section>
 
 </div>
    )
}
export default  Servicedetail